// extracted by mini-css-extract-plugin
export default {"container":"Plane_container__VmMjr","menus":"Plane_menus__ITgGG","menu":"Plane_menu__pYbxN","target":"Plane_target__IY6pv","console":"Plane_console__cjAUG"};